import GoTrue from "gotrue-js";

// Instantiate the GoTrue auth client with an optional configuration

const auth = new GoTrue({
    APIUrl: "https://productplaybook.netlify.app/.netlify/identity",
    audience: "",
    setCookie: false
});

export default auth



// WEBPACK FOOTER //
// ./src/utils/auth.js